import React from 'react';

export const BotIcon = ({ 
  className = "w-12 h-12 pr-2", 
  fill = "#000000", 
  width = "800px", 
  height = "800px" 
}) => (
  <svg
    className={className} 
    fill={fill} 
    width={width} 
    height={height} 
    viewBox="0 0 32 32" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>chat-bot</title>
    <path d="M16,19a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,19Z"/>
    <path d="M20,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,8Z"/>
    <path d="M12,8a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,8Z"/>
    <path d="M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V6a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,6V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V6A3.9988,3.9988,0,0,1,6,2H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"/>
    <rect width="32" height="32" fill="none"/>
  </svg>
);
